import { render, staticRenderFns } from "./buscadorModal.vue?vue&type=template&id=99bb22a4&scoped=true"
import script from "./buscadorModal.vue?vue&type=script&lang=js"
export * from "./buscadorModal.vue?vue&type=script&lang=js"
import style0 from "./buscadorModal.vue?vue&type=style&index=0&id=99bb22a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bb22a4",
  null
  
)

export default component.exports